import React from 'react';
import { Check, Download, Smartphone, BookOpen } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { optimizeImg, buildSrcSet } from '../utils/img';
const HERO_SRC = 'https://cdn.magicpatterns.com/uploads/mn2tVderiXGBBJZpuSjciP/remedios_hero_optimizada_1200.webp';
export function Hero() {
  return <section className="relative pt-8 md:pt-12 pb-8 md:pb-10 px-5 bg-cream-100 texture-paper overflow-hidden" data-id="element-133">
      <div className="max-w-5xl mx-auto" data-id="element-134">
        {/* Top trust badge */}
        <div className="flex justify-center mb-6" data-id="element-135">
          <div className="inline-flex items-center gap-2 bg-olive-50 text-olive-700 px-4 py-1.5 rounded-full text-xs font-semibold border border-olive-100 tracking-wide" data-id="element-136">
            <span data-id="element-137">🏆</span>5 EBOOKS PREMIUM + 10 BONOS EXCLUSIVOS
          </div>
        </div>

        {/* Headline */}
        <h1 className="text-center font-serif font-medium text-3xl md:text-5xl lg:text-6xl leading-[1.1] text-ink-900 mb-5 max-w-4xl mx-auto" data-id="element-138">
          Más de{' '}
          <span className="italic text-olive-600" data-id="element-139">
            1,500 soluciones naturales
          </span>{' '}
          en una sola biblioteca
        </h1>

        {/* Subtitle */}
        <p className="text-center text-base md:text-lg text-ink-700 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-140">
          Accede a remedios naturales, tés curativos, botiquín natural, cocina
          antiinflamatoria y huerta medicinal. Todo organizado para encontrar
          respuestas en segundos.
        </p>

        {/* Product image — full collection, static for fast LCP */}
        <div className="block mb-7 md:mb-10" data-id="element-141">
          <div className="relative max-w-2xl mx-auto" data-id="element-142">
            <div className="absolute inset-0 bg-olive-200/40 blur-3xl rounded-full" data-id="element-143"></div>
            <img src={optimizeImg(HERO_SRC, {
            w: 672,
            q: 72,
            dpr: 1
          })} srcSet={buildSrcSet(HERO_SRC, [360, 540, 720, 900, 1200], 72)} sizes="(max-width: 768px) 92vw, 672px" alt="Biblioteca completa de bienestar natural — 5 ebooks premium" width={1200} height={800} loading="eager"
          // @ts-expect-error fetchpriority is a valid HTML attribute
          fetchpriority="high" className="relative w-full drop-shadow-2xl" data-id="element-144" />
          </div>
        </div>

        {/* Quick value bullets */}
        <div className="max-w-md mx-auto mb-6 md:mb-8 space-y-2.5" data-id="element-145">
          {['Más de 1,500 soluciones naturales', '5 ebooks premium especializados', '10 bonos exclusivos de regalo', 'Acceso inmediato y de por vida'].map((bullet, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-146">
              <div className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-olive-100 flex items-center justify-center" data-id="element-147">
                <Check className="w-3 h-3 text-olive-700" strokeWidth={3} data-id="element-148" />
              </div>
              <span className="text-sm md:text-base text-ink-800 font-medium" data-id="element-149">
                {bullet}
              </span>
            </div>)}
        </div>

        {/* Price block */}
        <div className="text-center mb-6" data-id="element-150">
          <p className="text-sm text-ink-600 mb-1" data-id="element-151">
            Antes <span className="line-through" data-id="element-152">$999 MXN</span>
          </p>
          <div className="flex items-baseline justify-center gap-2" data-id="element-153">
            <span className="text-xs font-medium text-olive-600 uppercase tracking-wider" data-id="element-154">
              Hoy
            </span>
            <span className="text-4xl md:text-5xl font-serif font-semibold text-ink-900" data-id="element-155">
              $299
            </span>
            <span className="text-sm text-ink-600 font-medium" data-id="element-156">MXN</span>
          </div>
        </div>

        {/* CTA */}
        <CTAButton subtext="Pago seguro · Acceso inmediato · Descarga digital" data-id="element-157" />

        {/* Trust line */}
        <div className="mt-7 md:mt-10 flex items-center justify-center gap-6 md:gap-8 text-ink-600" data-id="element-158">
          <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-159">
            <Download className="w-4 h-4" data-id="element-160" />
            <span data-id="element-161">Acceso inmediato</span>
          </div>
          <div className="w-1 h-1 rounded-full bg-ink-500" data-id="element-162"></div>
          <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-163">
            <Smartphone className="w-4 h-4" data-id="element-164" />
            <span data-id="element-165">Celular y PC</span>
          </div>
          <div className="w-1 h-1 rounded-full bg-ink-500" data-id="element-166"></div>
          <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-167">
            <BookOpen className="w-4 h-4" data-id="element-168" />
            <span data-id="element-169">PDF digital</span>
          </div>
        </div>
      </div>
    </section>;
}